<div class="icon-toggle-container">
	<fa-icon
		*ngIf="value; else default"
		[icon]="onIcon"
		[ngStyle]="{
			color: onColor ? onColor : 'var(--portals-theme-primary)'
		}"
	></fa-icon>

	<ng-template #default>
		<fa-icon
			*ngIf="offColor"
			[icon]="offIcon"
			[ngStyle]="{
				color: offColor ? offColor : 'var(--portals-theme-accent)'
			}"
		></fa-icon>
	</ng-template>
</div>
